export default {
  init (vue) {
    return {
      query () {
        return vue.$http.get(`/api/v1/intentionalorders/groups?t=${Date.now()}`)
      }
    }
  }
}
